module.exports = __webpack_public_path__ + "static/media/schnee-kugeln.fb3bed56.svg";